export default "__VITE_ASSET__DUBKesVg__"